import React from 'react';
import { AGE_BANDS, AGE_BAND_COPY, AGE_SETTINGS, type AgeBand } from '../../store/ageSettings';

export interface AgePickerProps {
  selected: AgeBand | null;
  onPick: (band: AgeBand) => void;
}

/** Three big cards; the parent picks the child's age. */
export const AgePicker: React.FC<AgePickerProps> = ({ selected, onPick }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    {AGE_BANDS.map((band) => {
      const copy = AGE_BAND_COPY[band];
      const active = selected === band;
      return (
        <button
          key={band}
          type="button"
          data-name={`age-${band}`}
          aria-pressed={active}
          onClick={() => onPick(band)}
          className={`min-h-[140px] rounded-3xl p-5 text-left shadow transition active:scale-95 ${
            active ? 'bg-[#FFE66D] ring-4 ring-white' : 'bg-white/95 hover:shadow-lg'
          }`}
        >
          <span className="block text-5xl mb-2" aria-hidden>
            {copy.emoji}
          </span>
          <span className="block font-display text-2xl font-bold text-gray-800">{copy.title}</span>
          <span className="block font-body text-gray-600 mt-1">{copy.blurb}</span>
          <span className="block font-body text-xs text-gray-500 mt-2">
            {AGE_SETTINGS[band].levelsPerSession} nivåer per økt
          </span>
        </button>
      );
    })}
  </div>
);

/** First launch: shown instead of the home screen until an age is picked. */
export const FirstRunAgeScreen: React.FC<{ onPick: (band: AgeBand) => void }> = ({ onPick }) => (
  <div
    className="min-h-screen bg-gradient-to-b from-[#8ecae6] via-[#A8D8EA] to-[#669bbc] px-4 py-10"
    data-name="first-run-age"
  >
    <div className="mx-auto max-w-4xl">
      <header className="mb-8 text-center">
        <h1 className="font-display text-4xl md:text-5xl font-bold text-white drop-shadow-lg">
          Hvor gammel er barnet?
        </h1>
        <p className="mt-3 font-body text-white/90 text-lg max-w-xl mx-auto">
          For voksne: velg alder, så tilpasser vi nivåer, hjelp og lengden på hver økt. Du kan
          endre dette senere under «For voksne».
        </p>
      </header>
      <AgePicker selected={null} onPick={onPick} />
    </div>
  </div>
);

export default AgePicker;
